import { render, staticRenderFns } from "./ModalFormCliente.vue?vue&type=template&id=b42ed2fe"
import script from "./ModalFormCliente.vue?vue&type=script&lang=js"
export * from "./ModalFormCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports